/**
 * Arayüz teması (görsel kabuk) seçenekleri.
 *
 * classic : Eski tasarım. body üzerinde hiçbir attribute bulunmaz. Yalnızca
 *           kullanıcı açıkça seçerse (ya da acil durum anahtarı kapatılırsa).
 * modern  : Yeni tasarım — **varsayılan**. body[data-ui-theme="modern"].
 *
 * Faz 1'de tercih yalnızca localStorage'da tutulur (bkz. docs/markdowns/yeni-tasarim-plan.md).
 */
export type UiTheme = 'classic' | 'modern';

export const UI_THEME_CLASSIC: UiTheme = 'classic';
export const UI_THEME_MODERN: UiTheme = 'modern';

/** localStorage anahtarı. index.html içindeki FOUC script'i de aynı anahtarı okur. */
export const UI_THEME_KEY = 'uiTheme';

/** body üzerine yazılan attribute adı. Tüm modern tema CSS'i bu attribute altında scope'lanır. */
export const UI_THEME_ATTRIBUTE = 'data-ui-theme';

/** Modern kabukta sol menünün daraltılmış olup olmadığı bilgisi. */
export const UI_SIDEBAR_COLLAPSED_KEY = 'uiSidebarCollapsed';

/**
 * Modern temanın açık/koyu modu.
 *
 * Ayrı bir attribute (`data-ui-mode="dark"`) olarak uygulanır; tema scope'u
 * (`data-ui-theme="modern"`) değişmez, yalnızca tasarım token'ları yeniden
 * tanımlanır. Klasik temada bu attribute hiçbir şey ifade etmez.
 */
export type UiThemeMode = 'light' | 'dark';

export const UI_MODE_LIGHT: UiThemeMode = 'light';
export const UI_MODE_DARK: UiThemeMode = 'dark';

/** localStorage anahtarı. index.html içindeki FOUC script'i de bunu okur. */
export const UI_MODE_KEY = 'uiThemeMode';

/** body üzerine yazılan attribute adı. */
export const UI_MODE_ATTRIBUTE = 'data-ui-mode';
